<template>
    <label v-if="label" class="form-label">{{ label }}</label>

    <select
        v-bind="{ ...$attrs }"
        class="select"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
        <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.value"
            :selected="option.value === modelValue"
            :class="{ error: error }"
        >
            {{ option.name }}
        </option>
    </select>

    <div v-if="error" class="form-error">{{ error }}</div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            label: {
                type: String,
                default: ''
            },
            modelValue: {
                type: [Number, String],
                default: ''
            },
            options: {
                type: Object,
                required: true
            },
            error: String
        },
        emits: ['update:modelValue'],
        methods: {
            handleInputChange(event) {
                return event.target.value
            }
        }
    }
</script>
